module.exports = __webpack_public_path__ + "img/grin-tongue-squint.1b7a9df4.svg";